var map = {
	"./locale-provider/ar_EG.js": "./components/locale-provider/ar_EG.js",
	"./locale-provider/bg_BG.js": "./components/locale-provider/bg_BG.js",
	"./locale-provider/ca_ES.js": "./components/locale-provider/ca_ES.js",
	"./locale-provider/cs_CZ.js": "./components/locale-provider/cs_CZ.js",
	"./locale-provider/da_DK.js": "./components/locale-provider/da_DK.js",
	"./locale-provider/de_DE.js": "./components/locale-provider/de_DE.js",
	"./locale-provider/el_GR.js": "./components/locale-provider/el_GR.js",
	"./locale-provider/en_GB.js": "./components/locale-provider/en_GB.js",
	"./locale-provider/en_US.js": "./components/locale-provider/en_US.js",
	"./locale-provider/es_ES.js": "./components/locale-provider/es_ES.js",
	"./locale-provider/et_EE.js": "./components/locale-provider/et_EE.js",
	"./locale-provider/fa_IR.js": "./components/locale-provider/fa_IR.js",
	"./locale-provider/fi_FI.js": "./components/locale-provider/fi_FI.js",
	"./locale-provider/fr_BE.js": "./components/locale-provider/fr_BE.js",
	"./locale-provider/fr_FR.js": "./components/locale-provider/fr_FR.js",
	"./locale-provider/he_IL.js": "./components/locale-provider/he_IL.js",
	"./locale-provider/hi_IN.js": "./components/locale-provider/hi_IN.js",
	"./locale-provider/hr_HR.js": "./components/locale-provider/hr_HR.js",
	"./locale-provider/hu_HU.js": "./components/locale-provider/hu_HU.js",
	"./locale-provider/hy_AM.js": "./components/locale-provider/hy_AM.js",
	"./locale-provider/id_ID.js": "./components/locale-provider/id_ID.js",
	"./locale-provider/is_IS.js": "./components/locale-provider/is_IS.js",
	"./locale-provider/it_IT.js": "./components/locale-provider/it_IT.js",
	"./locale-provider/ja_JP.js": "./components/locale-provider/ja_JP.js",
	"./locale-provider/kn_IN.js": "./components/locale-provider/kn_IN.js",
	"./locale-provider/ko_KR.js": "./components/locale-provider/ko_KR.js",
	"./locale-provider/ku_IQ.js": "./components/locale-provider/ku_IQ.js",
	"./locale-provider/lv_LV.js": "./components/locale-provider/lv_LV.js",
	"./locale-provider/mk_MK.js": "./components/locale-provider/mk_MK.js",
	"./locale-provider/mn_MN.js": "./components/locale-provider/mn_MN.js",
	"./locale-provider/ms_MY.js": "./components/locale-provider/ms_MY.js",
	"./locale-provider/nb_NO.js": "./components/locale-provider/nb_NO.js",
	"./locale-provider/ne_NP.js": "./components/locale-provider/ne_NP.js",
	"./locale-provider/nl_BE.js": "./components/locale-provider/nl_BE.js",
	"./locale-provider/nl_NL.js": "./components/locale-provider/nl_NL.js",
	"./locale-provider/pl_PL.js": "./components/locale-provider/pl_PL.js",
	"./locale-provider/pt_BR.js": "./components/locale-provider/pt_BR.js",
	"./locale-provider/pt_PT.js": "./components/locale-provider/pt_PT.js",
	"./locale-provider/ro_RO.js": "./components/locale-provider/ro_RO.js",
	"./locale-provider/ru_RU.js": "./components/locale-provider/ru_RU.js",
	"./locale-provider/sk_SK.js": "./components/locale-provider/sk_SK.js",
	"./locale-provider/sl_SI.js": "./components/locale-provider/sl_SI.js",
	"./locale-provider/sr_RS.js": "./components/locale-provider/sr_RS.js",
	"./locale-provider/sv_SE.js": "./components/locale-provider/sv_SE.js",
	"./locale-provider/ta_IN.js": "./components/locale-provider/ta_IN.js",
	"./locale-provider/th_TH.js": "./components/locale-provider/th_TH.js",
	"./locale-provider/tr_TR.js": "./components/locale-provider/tr_TR.js",
	"./locale-provider/uk_UA.js": "./components/locale-provider/uk_UA.js",
	"./locale-provider/vi_VN.js": "./components/locale-provider/vi_VN.js",
	"./locale-provider/zh_CN.js": "./components/locale-provider/zh_CN.js",
	"./locale-provider/zh_TW.js": "./components/locale-provider/zh_TW.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/locale-provider\\/(?!__tests__).+_.+\\.js$";